/**
 * Appends optional query params to the Trips widget URL from the API.
 * Use when Trips provides a flag (e.g. default domestic view) — set REACT_APP_TRIPS_WIDGET_EXTRA_QUERY.
 */
export function appendTripsWidgetQuery(bookingURL: string): string {
  const raw = process.env.REACT_APP_TRIPS_WIDGET_EXTRA_QUERY?.trim();
  if (!raw) return bookingURL;
  const fragment = raw.startsWith("&") ? raw : `&${raw}`;
  return `${bookingURL}${fragment}`;
}
